<template lang="pug">
  v-app
    router-view
    pwa
</template>

<script> 
import Pwa from '@/components/Pwa'
export default {
  name: "App",
  components: {
    Pwa
  },
  mounted () {
    this.setCSSVariables();
  },
  methods: {
    setCSSVariables () {

      let cssVariables = '';

      if (this.isThaiCharoenPlus) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #ff0000;
              --bg-nav-main-color: #404040;
              --bg-secondary-color: #ff5757;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #920a0a;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #ff5757;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #ffc0c0;
              --bg-primary-300: #ffc0c0;
              --bg-primary-400: #ff0000;
              --bg-primary-550: #b10303;

              --bg-active: #ff0000;

              --bg-btn-primary-300: #ffc0c0;
              --bg-btn-primary-550: #b10303;


              --v3-base-color-5: #ff5757;
              --v3-base-color-10: #ff2323;
              --v3-base-color-15: #ff0000;
              --v3-base-color-20: #b10303;

              --v3-base-color-5-main: #ff5757;
              --v3-base-color-15-main: #ff0000;

              --v3-btn-login-color-20: #b10303;
              --v3-btn-login-color-20-end: #b10303;

              --v3-bar-color-5: #ff5757;
              --v3-bar-color-15: #ff0000;

              --v3-footer-color-10: #ff2323;
              --v3-footer-color-15: #ff0000;

              --v3-sec-color-10: #404040;
              --v3-sec-color-20: #ffffff;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #D0D0D0;
              --v3-sec-color-35: #ff0000;
              --v3-select-main-100: #000000;

              --v3-header-table: #404040;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ededed;

              --v3-btn-login-color: #ff2323;
          }
        `;
      } else if (this.isSevenColor) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #0004ff;
              --bg-nav-main-color: #0004ff;
              --bg-secondary-color: #00b2ff;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #920a0a;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #00b2ff;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #b6e8ff;
              --bg-primary-300: #75d7ff;
              --bg-primary-400: #008ad4;
              --bg-primary-550: #005c8d;

              --bg-active: #ff30e3;

              --bg-btn-primary-300: #75d7ff;
              --bg-btn-primary-550: #005c8d;

              --v3-base-color-5: #75d7ff;
              --v3-base-color-10: #2cc4ff;
              --v3-base-color-15: #00b2ff;
              --v3-base-color-20: #ff30e3;

              --v3-base-color-5-main: #75d7ff;
              --v3-base-color-15-main: #00b2ff;

              --v3-btn-login-color-20: #ff30e3;
              --v3-btn-login-color-20-end: #ff30e3;

              --v3-bar-color-5: #75d7ff;
              --v3-bar-color-15: #00b2ff;

              --v3-footer-color-10: #2cc4ff;
              --v3-footer-color-15: #00b2ff;

              --v3-sec-color-10: #0004ff;
              --v3-sec-color-20: #ffffff;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #D0D0D0;
              --v3-sec-color-35: #ff30e3;
              --v3-select-main-100: #000000;

              --v3-header-table: #00b2ff;
              --theme-main-text-color: #131f36;

              --form-control-bg-color: #ededed; 

              --v3-btn-login-color: #00b800;
          }
        `;
      } else if (this.isThaisiam) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #488ef8;
              --bg-nav-main-color: #488ef8;
              --bg-secondary-color: #92c7fe;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #172654;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #92c7fe;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #dbebfe;
              --bg-primary-300: #bfdcfe;
              --bg-primary-400: #5fa8fb;
              --bg-primary-550: #2366ed;

              --bg-active: #1c50d9;

              --bg-btn-primary-300: #bfdcfe;
              --bg-btn-primary-550: #2366ed;

              --v3-base-color-5: #78c4fa;
              --v3-base-color-10: #488ef8;
              --v3-base-color-15: #78c4fa;
              --v3-base-color-20: #532aa6;
              
              --v3-base-color-5-main: #78c4fa;
              --v3-base-color-15-main: #78c4fa;

              --v3-btn-login-color-20: #532aa6;
              --v3-btn-login-color-20-end: #532aa6;

              --v3-bar-color-5: #78c4fa;
              --v3-bar-color-15: #78c4fa;

              --v3-footer-color-10: #488ef8;
              --v3-footer-color-15: #78c4fa;

              --v3-sec-color-10: #488ef8;
              --v3-sec-color-20: #ffffff;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #ffffff;
              --v3-sec-color-35: #78c4fa;
              --v3-select-main-100: #000000;

              --v3-header-table: #5fa8fb;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff; 

              --v3-btn-login-color: #0066cc;
          }
        `;
      } else if (this.isHuaypromt) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #236e46;
              --bg-nav-main-color: #236e46;
              --bg-secondary-color: #39ae6f;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #172654;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #39ae6f;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #c3efd7;
              --bg-primary-300: #95e0b7;
              --bg-primary-400: #5fc990;
              --bg-primary-550: #39ae6f;

              --bg-btn-primary-300: #95e0b7;
              --bg-btn-primary-550: #39ae6f;

              --bg-active: #1d4a33;


              --v3-base-color-5: #12502e;
              --v3-base-color-10: #236e46;
              --v3-base-color-15: #12502e;
              --v3-base-color-20: #215a3c;

              --v3-base-color-5-main: #12502e;
              --v3-base-color-15-main: #12502e;

              --v3-btn-login-color-20: #215a3c;
              --v3-btn-login-color-20-end: #215a3c;

              --v3-bar-color-5: #12502e;
              --v3-bar-color-15: #12502e;

              --v3-footer-color-10: #236e46;
              --v3-footer-color-15: #12502e;

              --v3-sec-color-10: #236e46;
              --v3-sec-color-20: #39ae6f;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #ffffff;
              --v3-sec-color-35: #12502e;
              --v3-select-main-100: #000000;

              --v3-header-table: #236e46;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff; 

              --v3-btn-login-color: #47e187;
          }
        `;
      } else if (this.isLottoslot88) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #D40030;
              --bg-nav-main-color: #D40030;
              --bg-secondary-color: #ff2c4e;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #172654;
              --main-font-color: #236e46;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #ff2c4e;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #ffc8ce;
              --bg-primary-300: #d40030;
              --bg-primary-400: #fff0f1;
              --bg-primary-550: #ff6378;

              --bg-active: #94072f;

              --bg-btn-primary-300: #ff9ba6;
              --bg-btn-primary-550: #ff9ba6;

              --v3-base-color-5: #ffc8ce;
              --v3-base-color-10: #ff9ba6;
              --v3-base-color-15: #ff2c4e;
              --v3-base-color-20: #ff2c4e;

              --v3-base-color-5-main: #ffc8ce;
              --v3-base-color-15-main: #ff2c4e;

              --v3-btn-login-color-20: #ff2c4e;
              --v3-btn-login-color-20-end: #ff2c4e;

              --v3-bar-color-5: #ffffff;
              --v3-bar-color-15: #ffffff;

              --v3-footer-color-10: #D40030;
              --v3-footer-color-15: #94072f;

              --v3-sec-color-10: #D40030;
              --v3-sec-color-20: #BEBEBE;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #ffffff;
              --v3-sec-color-35: #D40030;
              --v3-select-main-100: #000000;

              --v3-header-table: #D40030;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff; 

              --v3-btn-login-color: #ff2c4e;
          }
        `;
      } else if (this.isJertjarat) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #C70025;
              --bg-nav-main-color: #C70025;
              --bg-secondary-color: #ff264e;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #db8104;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #ff5757;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #ffc0c0;
              --bg-primary-300: #ff9494;
              --bg-primary-400: #fc0634;
              --bg-primary-550: #c70025;

              --bg-active: #920a0a;

              --bg-btn-primary-300: #54d454;
              --bg-btn-primary-550: #54d454;

              --v3-base-color-5: #d4b670;
              --v3-base-color-10: #d4b670;
              --v3-base-color-15: #c59943;
              --v3-base-color-20: #c59943;

              --v3-base-color-5-main: #d4b670;
              --v3-base-color-15-main: #c59943;

              --v3-btn-login-color-20: #ffc107;
              --v3-btn-login-color-20-end: #ffc107;

              --v3-bar-color-5: #d4b670;
              --v3-bar-color-15: #c59943;

              --v3-footer-color-10: #d4b670;
              --v3-footer-color-15: #c59943;

              --v3-sec-color-10: #c70025;
              --v3-sec-color-20: #000000;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #fffaea;
              --v3-sec-color-35: #c70025;
              --v3-select-main-100: #4f4f4f;

              --v3-header-table: #c70025;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff;

              --v3-btn-login-color: #c59943;
          }
        `;
      } else if (this.isChokCharoen) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #3B72FF;
              --bg-nav-main-color: #3B72FF;
              --bg-secondary-color: #8ebaff;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #db8104;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #5994ff;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #bcd4ff;
              --bg-primary-300: #8ebaff;
              --bg-primary-400: #5994ff;
              --bg-primary-550: #3b72ff;

              --bg-active: #192b8f;

              --bg-btn-primary-300: #8ebaff;
              --bg-btn-primary-550: #5994ff;

              --v3-base-color-5: #8ebaff;
              --v3-base-color-10: #3b72ff;
              --v3-base-color-15: #1b49f5;
              --v3-base-color-20: #1b49f5;

              --v3-base-color-5-main: #3771fa;
              --v3-base-color-15-main: #bed6ff;

              --v3-btn-login-color-20: #1b49f5;
              --v3-btn-login-color-20-end: #1b49f5;

              --v3-bar-color-5: #5994ff;
              --v3-bar-color-15: #bcd4ff;
              
              --v3-footer-color-10: #1436e1;
              --v3-footer-color-15: #3b72ff;

              --v3-sec-color-10: #3B72FF;
              --v3-sec-color-20: #d9e6ff;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #D0D0D0;
              --v3-sec-color-35: #4f4f4f;
              --v3-select-main-100: #4f4f4f;

              --v3-header-table: #5994ff;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff;

              --v3-btn-login-color: #F7AA0A;
          }
        `;
      } else if (this.isBooncharern) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #e2a81e;
              --bg-nav-main-color: #1a4438;
              --bg-secondary-color: #eed65b;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #db8104;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #eac63a;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #feec89;
              --bg-primary-300: #fddc4c;
              --bg-primary-400: #fdca22;
              --bg-primary-550: #f7aa0a;

              --bg-active: #93460d;

              --bg-btn-primary-300: #fada49;
              --bg-btn-primary-550: #f7aa0a;

              --v3-base-color-5: #b98a08;
              --v3-base-color-10: #eac63a;
              --v3-base-color-15: #fada49;
              --v3-base-color-20: #841B1D;

              --v3-base-color-5-main: #b98a08;
              --v3-base-color-15-main: #fada49;

              --v3-btn-login-color-20: #eac63a;
              --v3-btn-login-color-20-end: #847021;

              --v3-bar-color-5: #b98a08;
              --v3-bar-color-15: #fada49;
              
              --v3-footer-color-10: #1a4438;
              --v3-footer-color-15: #1a4438;

              --v3-sec-color-10: #0f352a;
              --v3-sec-color-20: #0e251b;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #D0D0D0;
              --v3-sec-color-35: #4f4f4f;
              --v3-select-main-100: #4f4f4f;

              --v3-header-table: #F7AA0A;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff;

              --v3-btn-login-color: #F7AA0A;
          }
        `;
      } else if (this.isCherdchai) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #ff9d00;
              --bg-nav-main-color: #ff9c01;
              --bg-secondary-color: #c74700;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #db8104;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #c74700;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #ffc46b;
              --bg-primary-300: #ff9f2f;
              --bg-primary-400: #ff8007;
              --bg-primary-550: #f96300;

              --bg-active: #920a0a;

              --bg-btn-primary-300: #54d454;
              --bg-btn-primary-550: #54d454;

              --v3-base-color-5: #ffc46b;
              --v3-base-color-10: #ff9f2f;
              --v3-base-color-15: #ff8007;
              --v3-base-color-20: #f96300;

              --v3-base-color-5-main: #fee293;
              --v3-base-color-15-main: #fea315;

              --v3-btn-login-color-20: #eac63a;
              --v3-btn-login-color-20-end: #847201;

              --v3-bar-color-5: #ff8e01;
              --v3-bar-color-15: #ff9c01;

              --v3-footer-color-10: #fee293;
              --v3-footer-color-15: #fea315;

              --v3-sec-color-10: #fbefa5;
              --v3-sec-color-20: #ffffff;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #fffaea;
              --v3-sec-color-35: #c74700;
              --v3-select-main-100: #4f4f4f;

              --v3-header-table: #ff9c01;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff;

              --v3-btn-login-color: #c59943;
          }
        `;
      } else if (this.isSapcharern) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #e70000;
              --bg-nav-main-color: #000000;
              --bg-secondary-color: #c74700;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #db8104;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #e70000;
              --bg-secondary-color-v2-end: #be0000;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #ffbbbb;
              --bg-primary-300: #ff8b8b;
              --bg-primary-400: #ff4949;
              --bg-primary-550: #ff0000;

              --bg-active: #920a0a;

              --bg-btn-primary-300: #ff8b8b;
              --bg-btn-primary-550: #ff0000;

              --v3-base-color-5: #ff4949;
              --v3-base-color-10: #ff1111;
              --v3-base-color-15: #ff0000;
              --v3-base-color-20: #e70000;

              --v3-base-color-5-main: #fcda4b;
              --v3-base-color-15-main: #b65c09;

              --v3-btn-login-color-20: #f9f1b1;
              --v3-btn-login-color-20-end: #cc972f;

              --v3-bar-color-5: #fcda4b;
              --v3-bar-color-15: #b65c09;

              --v3-footer-color-10: #870000;
              --v3-footer-color-15: #870000;

              --v3-sec-color-10: #880000;
              --v3-sec-color-20: #000000;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #fffaea;
              --v3-sec-color-35: #c74700;
              --v3-select-main-100: #4f4f4f;

              --v3-header-table: #be0000;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #d9d9d9;

              --v3-btn-login-color: #c59943;
          }
        `;
      } else if (this.isPacharern) {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #eac63a;
              --bg-nav-main-color: #3B72FF;
              --bg-secondary-color: #8ebaff;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #db8104;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #5994ff;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #bcd4ff;
              --bg-primary-300: #8ebaff;
              --bg-primary-400: #5994ff;
              --bg-primary-550: #3b72ff;

              --bg-active: #192b8f;

              --bg-btn-primary-300: #8ebaff;
              --bg-btn-primary-550: #5994ff;

              --v3-base-color-5: #8ebaff;
              --v3-base-color-10: #3b72ff;
              --v3-base-color-15: #1b49f5;
              --v3-base-color-20: #1b49f5;

              --v3-base-color-5-main: #ff652a;
              --v3-base-color-15-main: #f1e03c;

              --v3-btn-login-color-20: #f1e03c;
              --v3-btn-login-color-20-end: #ff652a;

              --v3-bar-color-5: #c88317;
              --v3-bar-color-15: #eac63a;
              
              --v3-footer-color-10: #1436e1;
              --v3-footer-color-15: #3b72ff;

              --v3-sec-color-10: #3B72FF;
              --v3-sec-color-20: #09205A;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #D0D0D0;
              --v3-sec-color-35: #4f4f4f;
              --v3-select-main-100: #4f4f4f;

              --v3-header-table: #eac63a;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff;

              --v3-btn-login-color: #F7AA0A;
          }
        `;
      } else {
        cssVariables = `
          :root {
              --bg-color: #ffffff;
              --bg-home: #f0f5ff;
              /* --bg-main-color: #0e2551; */
              --bg-main-color: #f7aa0a;
              --bg-nav-main-color: #000;
              --bg-secondary-color: #fdca22;
              --bg-footer: #fdca22;
              --bg-yeekee-color: #fdca22;
              --color-disabled: #1274e1;
              --color-highlight: #db8104;
              --main-font-color: #ffffff;

              --bg-home-v2: #f0f5ff;
              /* --bg-main-color-v2: #e7efff; */
              --bg-main-color-v2: #f0f5ff;
              /* --bg-main-color-v2-end: #0e2551; */
              --bg-main-color-v2-end: #f0f5ff;
              --bg-main-color-2-v2: #1274e1;
              --bg-main-color-3-v2: #36cea0;
              --bg-main-color-4-v2: #1274e1;
              --bg-secondary-color-v2: #fdca22;
              --bg-secondary-color-v2-end: #f7aa0a;
              --bg-secondary-color-2-v2: #fdca22;
              --bg-card-date-round-v2: #000;
              --btn-activate-index-v2: #5a70ba;
              --btn-select-activate-v2: #fd8b23;
              --btn-remove-v2: #6bb0e4;
              --btn-clear-all-v2: #1274e1;
              --btn-grey-v2: #1274e1;
              --btn-grey-2-v2: #bcbcbc;
              --btn-limit-activate-v2: #fd686d;
              --btn-out-stock-activate-v2: #fd686d;
              --btn-stake-not-activate-v2: #b8b8b8;
              --btn-show-same-number-v2: #dc3546;
              --card-color-grey-v2: #e5e9ed;
              --card-color-reward-v2: #243197;
              --card-round-header-v2: #080808;
              --card-color-red-v2: #dc3546;

              --font-first-v2: #25386d;
              --font-second-v2: #6bb0e4;
              --font-third-v2: #243197;
              --font-fourth-v2: #ffffff;
              --font-fifth-v2: #c7322f;

              /* power ball */
              --btn-activate-whiteball-v2: #1a4e92;
              --btn-activate-powerball-v2: #c52736;
              --btn-cancel-powerball-v2: #c52736;
              --btn-buy-ticket-powerball-v2: #5b95df;
              --card-order-list-v2: #f2f2f2;
              --card-power-ball-v2: #1a4e92;
              --card-power-ball-2-v2: #1a2a39;
              --card-open-status: #222222;
              --bg-color-power-ball: #d0312d;
              --loading-power-ball-v2: #f2f2f2;

              --bg-sub-card-active: #25386d;
              --bg-sub-card-no-active: #5991ff;

              /* --bg-primary: #fff; */
              --bg-primary-250: #feec89;
              --bg-primary-300: #fddc4c;
              --bg-primary-400: #fdca22;
              --bg-primary-550: #f7aa0a;

              --bg-active: #93460d;

              --bg-btn-primary-300: #fddc4c;
              --bg-btn-primary-550: #f7aa0a;

              --v3-base-color-5: #b55b08;
              --v3-base-color-10: #F7AA0A;
              --v3-base-color-15: #fddc4c;
              --v3-base-color-20: #841B1D;

              --v3-base-color-5-main: #b55b08;
              --v3-base-color-15-main: #fddc4c;

              --v3-btn-login-color-20: #841B1D;
              --v3-btn-login-color-20-end: #841B1D;

              --v3-bar-color-5: #b55b08;
              --v3-bar-color-15: #fddc4c;
              
              --v3-footer-color-10: #F7AA0A;
              --v3-footer-color-15: #fddc4c;

              --v3-sec-color-10: #000;
              --v3-sec-color-20: #4f4f4f;
              --v3-sec-color-25: #A9A7A7;
              --v3-sec-color-30: #D0D0D0;
              --v3-sec-color-35: #4f4f4f;
              --v3-select-main-100: #4f4f4f;

              --v3-header-table: #F7AA0A;
              --theme-main-text-color: #ffffff;

              --form-control-bg-color: #ffffff;

              --v3-btn-login-color: #F7AA0A;
          }
        `;
      }

      const styleElement = document.createElement('style');
      styleElement.textContent = cssVariables;
      document.head.appendChild(styleElement);
      }
  },
};
</script> 